import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "@mui/material";
import { Menu } from "@mui/material";
import { ListItemText } from "@mui/material";
import { Divider } from "@mui/material";
import { ListItemIcon } from "@mui/material";

import Avatar from "../../../avatar/avatar";
import ConfirmPopUp from "../../../confirm-modal/confirm-modal";
import ResetPasswordModal from "../../../reset-password-modal/reset-password-modal";
import Typography from "../../../typography/typography";
import { Eye } from "../../../icons";
import { images } from "../../../../assets/images";
import { useAuth } from '@erpsquad/common/runtime';
import formatText from "../../../../utils/format-text";
import { getApiConfig } from "@/utils";

export function UserMenu() {
  const { t } = useTranslation();
  const { logout, user } = useAuth();
  const config = getApiConfig();

  const u_data = localStorage.getItem("_u_data") || undefined;
  const userData = u_data ? JSON.parse(u_data) : "";

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [logoutConfirmation, setLogoutConfirmation] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);

  const isMenuOpen = Boolean(anchorEl);
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogoutConfirmation = () => setLogoutConfirmation(!logoutConfirmation);

  return (
    <>
      {localStorage.getItem("_tid") && (
        <button className="hdr-user-btn" type="button" onClick={handleProfileMenuOpen}>
          <div className="user-avatar">
            {user?.profile_image
              ? <img src={`${config?.s3BucketUrl}${user.profile_image}`} alt={formatText(user?.full_name)} />
              : <span>{user?.full_name?.charAt(0)?.toUpperCase() || "U"}</span>
            }
          </div>
          <div className="user-meta">
            <span className="user-name">{user?.full_name}</span>
            <span className="user-role">{userData.role_name}</span>
          </div>
        </button>
      )}

      <Menu
        className="main-profile-menu"
        anchorEl={anchorEl}
        id="primary-search-account-menu"
        keepMounted
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem className="user-assigned">
          <span>{t("common.assigned_roles") || "Assigned roles"}</span>
        </MenuItem>
        <MenuItem className="user-data-wrap" value={userData.role_id}>
          <ListItemIcon>
            <Avatar size={27} alt={userData.role_name} />
          </ListItemIcon>
          <ListItemText className="size15">{userData.role_name}</ListItemText>
          <Typography variant="body2" color="text.secondary">
            <img src={images.tickicon} alt="Active" />
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem
          className="user-assigned"
          onClick={() => { setShowModal(true); setAnchorEl(null); }}
        >
          <ListItemIcon>
            <Eye fontSize="medium" width={20} height={20} htmlColor="#292D32" />
          </ListItemIcon>
          <ListItemText className="size15">{t("common.change_password")}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          className="menu-item-color"
          onClick={() => { handleLogoutConfirmation(); setAnchorEl(null); }}
        >
          <ListItemIcon>
            <img src={images.logout} alt="logout" />
          </ListItemIcon>
          <ListItemText className="size15">{t("common.logout")}</ListItemText>
        </MenuItem>
      </Menu>

      <ConfirmPopUp
        open={logoutConfirmation}
        title={t("common.logout")}
        description={t("common.logout_confirmation") || "Are you sure, you want to logout?"}
        onConfirm={() => logout()}
        onClose={handleLogoutConfirmation}
        fullWidth
        maxWidth="xs"
        buttonTexts={{ confirm: t("common.logout"), cancel: t("common.cancel") }}
      />
      <ResetPasswordModal showModal={showModal} setShowModal={setShowModal} />
    </>
  );
}

export default UserMenu;
